import { Notice, Stack, Text } from 'braid-design-system';
import { Section } from '../../common/section/Section';
import type { Statement } from '../../../';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

interface Props {
  mode: 'view' | 'edit';
  model: Statement;
  isMissionStatement?: boolean;
}

export function StatementSection({ mode, model, isMissionStatement }: Props) {
  const { t } = useTranslations(translations);
  const isEditMode = mode === 'edit';
  const { title, description = [] } = model;

  return (
    <Section
      mode={mode}
      heading={isMissionStatement ? t('Our mission statement') : title}
    >
      <Stack space="gutter">
        {isEditMode && !description.length ? (
          <Notice tone="info">
            <Text>
              {isMissionStatement
                ? t('Add a mission statement')
                : t('Add a custom statement')}
            </Text>
          </Notice>
        ) : (
          description.map((paragraph, index) => (
            <Text key={index} tone="secondary">
              {paragraph}
            </Text>
          ))
        )}
      </Stack>
    </Section>
  );
}
